import { Box } from '@mui/material'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

interface ContainerProps {
  sortable: boolean
  align?: 'center' | 'right' | 'left'
}

export const Container = styled(Box)<ContainerProps>`
  ${({ sortable, align }) => css`
    display: flex;
    align-items: center;
    justify-content: ${align ?? 'left'};
    gap: 8px;
    width: 100%;
    position: relative;

    ${sortable &&
    css`
      cursor: pointer;
      user-select: none;

      &:hover {
        opacity: 0.8;
      }
    `}
  `}
`

export const SortIcon = styled(Box)`
  width: 16px;
  height: 48px;
  padding-top: 3px;
  position: absolute;
  right: -8px;
  display: flex;
  align-items: center;
  justify-content: center;
`
